import React, { useState, useContext, useEffect, useRef } from "react";
import RightMenuTop from "./slides.submenucomponents/slideSubmenu";
import MyContext from "../../context/MyContext";
import ProjectContext from "../../context/ProjectContext";
import html2canvas from "html2canvas";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import swal from "sweetalert";
import TickerContext from "../../context/ticker";
// import loader from '../../assets/Loader/AssetLoader.json'
import loader from "../../assets/Loader/AssetLoader.json";
import arrayMove from "array-move";
import Lottie from "react-lottie";

import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { Tooltip } from "react-tippy";
import SlideTransitions from "./SlideTransitions";
import SlideTimeChangeModal from "./SlideTimeChangeModal";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import CharacterEditor from "../../Editor/CharacterEditor";
import { useForceUpdate } from "@react-spring/shared";
import { UploadFileSharp } from "@mui/icons-material";

var handler, optHandler;

const DragHandle = sortableHandle(() => (
  <div
    className="material-icons"
    style={{
      position: "absolute",
      fontSize: "20px",
      cursor: "grab",
      margin: "3px",
    }}
  >
    menu
  </div>
));

export const RightSide = () => {
  const [ShowTransitionPanel, setShowTransitionPanel] = useState({
    state: false,
    slideKey: -1,
    reset: false,
  });

  const _divRef = useRef(null);

  const [ActiveIndex, setActiveIndex] = useState({
    index: null,
    key: null,
    top: null,
  });
  const [ActiveList, setActiveList] = useState({
    index: null,
    key: null,
    top: null,
  });
  const { slides, setslides, setDeafultLoader } = useContext(ProjectContext);
  const [PreviousLayerData, setPreviousLayerData] = useState([]);

  const {
    LayersData,
    setLayersData,
    CanvasDisplay,
    setCanvasDisplay,
    Backgrounds,
    EditorZoom,
    characterEditor,
    popShow,
    setpopShow,
  } = useContext(MyContext);

  const { authenticationData, apiBaseurl } = useContext(AuthContext);

  const screenShotCanvas = () => {
    return new Promise(async (resolve_main, reject_main) => {
      let _editor = document.getElementsByClassName("Editor")[0];
      let testDiv = document.createElement("div");
      testDiv.style.width = _editor.clientWidth + "px";
      testDiv.style.height = _editor.clientHeight + "px";
      testDiv.style.position = "relative";
      // testDiv.style.display = "none";

      // let Canvas = document.createElement('canvas');
      // Canvas.width = _editor.clientWidth;
      // Canvas.height = _editor.clientHeight;
      // const getContext = () => Canvas.getContext('2d');
      // const ctx = getContext();

      if (Backgrounds.type === "color") {
        // ctx.fillStyle = Backgrounds.color;
        // ctx.fillRect(0, 0, Canvas.width, Canvas.height);
        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "gradient") {
        // var grd = ctx.createLinearGradient(0, 0, 0, Canvas.height);
        // grd.addColorStop(0, Backgrounds.gradient.FirstColor);
        // grd.addColorStop(1, Backgrounds.gradient.SecondColor);
        // ctx.fillStyle = grd;
        // ctx.fillRect(0, 0, Canvas.width, Canvas.height);
        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "image") {
        let img = await loadImage(
          authenticationData.ApiBaseURL + "/" + Backgrounds.Path
        );
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);
      } else if (Backgrounds.type === "Animated") {
        let img = await loadImage(
          authenticationData.ApiBaseURL + "/" + Backgrounds.Path
        );
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);

        // const ctx = BackgroundAnimation.current.getContext("2d");
        // var animationPath = authenticationData.ApiBaseURL + "/" + props.Item_Path;
        // const get = lottie.loadAnimation({
        //   name: props.Item_Path,
        //   renderer: "canvas",
        //   loop: true,
        //   autoplay: true,
        //   path: animationPath,
        //   rendererSettings: {
        //     context: ctx,
        //     clearCanvas: true,
        //     preserveAspectRatio: "xMidYMid meet",
        //   },
        // });
      }
      // else {
      //     ctx.fillStyle = "#ffffff";
      //     ctx.fillRect(0, 0, Canvas.width, Canvas.height);
      // }
      const print = (options) => {
        return new Promise(async (resolve, reject) => {
          const myOptions = Object.assign({}, options);
          let flip = "";
          if (myOptions.flip === "scaleX(-1)") {
            flip = " scaleX(-1)";
          }
          let rotater = "";
          if (myOptions.rotateAngle) {
            rotater = `rotate(${myOptions.rotateAngle}deg)`;
          }
          let transformer = rotater + flip;
          if (options.type === "image") {
            let img = await loadImage(options.ImageSrc);
            //ctx.drawImage(img, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            img.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            img.style.top = Math.round((myOptions.y * EditorZoom) / 100) + "px";
            img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            img.style.position = "absolute";
            img.style.transform = transformer;
            testDiv.appendChild(img);
          } else if (options.type === "Shape") {
            if (
              options.ShapePath.includes(authenticationData.ApiBaseURL + "/")
            ) {
              options.ShapePath = options.ShapePath.replace(
                authenticationData.ApiBaseURL + "/",
                ""
              );
            }
            let Shape = await loadImage(options.ShapePath);
            //document.getElementsByClassName(options.Name)[0]
            //ctx.drawImage(Shape, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            let _canvas = document.createElement("canvas");
            _canvas.width = Shape.width;
            _canvas.height = Shape.height;
            let _ctx = _canvas.getContext("2d");
            _ctx.drawImage(Shape, 0, 0);
            _canvas.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            _canvas.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            _canvas.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            _canvas.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            _canvas.style.position = "absolute";
            _canvas.style.transform = transformer;
            testDiv.appendChild(_canvas);
          } else if (options.type === "Video") {
            let video = await loadImage(options.ImageSrc); //document.getElementsByClassName(options.Name)[0]
            // ctx.drawImage(video, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            video.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            video.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            video.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            video.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            video.style.position = "absolute";
            video.style.transform = transformer;
            testDiv.appendChild(video);
          } else if (options.type === "Props") {
            let Props = await loadImage(options.PropImage);

            //ctx.drawImage(Props, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);

            Props.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            Props.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            Props.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            Props.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            Props.style.position = "absolute";
            Props.style.transform = transformer;
            testDiv.appendChild(Props);
          } else if (options.type === "Character") {
            let charDiv = document.getElementById(
              "Loader" + options.AnimationId
            );
            if (charDiv != null) {
              let svg = charDiv.firstChild;
              //let img = await loadCharacter(svg);
              //ctx.drawImage(svg, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
              let img = await loadCharacter(charDiv);
              img.style.left =
                Math.round((myOptions.x * EditorZoom) / 100) + "px";
              img.style.top =
                Math.round((myOptions.y * EditorZoom) / 100) + "px";
              img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
              img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
              img.style.position = "absolute";
              img.style.transform = transformer;
              testDiv.appendChild(img);
            }
          } else if (options.type === "text") {
            // ctx.font = `${options.fontWeight} ${options.fontSize + "px"} ${options.googleFontSetting.fontFamily}`;
            // ctx.fillStyle = options.textColor;
            // ctx.textAlign = options.Align;
            // var lineheight = options.fontSize;
            // let text = options.text.replaceAll('<br>', '\n');
            // text = text.replaceAll('&nbsp;', ' ');
            // var lines = text.split('\n');
            // let heightDivider = lines.length > 1 ? 2 : 1
            // for (var i = 0; i < lines.length; i++) {
            //     ctx.fillText(lines[i], options.x + (options.width / 2), options.y + (options.height / heightDivider) + (i * lineheight), options.width);
            // }
            let TopParent = document.createElement("div");
            TopParent.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            TopParent.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            TopParent.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            TopParent.style.height =
              (myOptions.height * EditorZoom) / 100 + "px";
            TopParent.style.position = "absolute";
            TopParent.style.transform = `rotate(${myOptions.rotateAngle}deg)`;
            let spanParant = document.createElement("div");
            spanParant.style.textAlign = myOptions.Align;
            let span = document.createElement("span");
            span.style.textDecoration = myOptions.textDec;
            span.style.fontStyle = myOptions.Fontstyle;
            span.style.fontWeight = myOptions.fontWeight;
            span.style.opacity = myOptions.opacity;
            span.style.color = myOptions.textColor;
            span.style.fontFamily = myOptions.googleFontSetting.fontFamily;
            span.style.fontSize =
              Math.round((myOptions.fontSize * EditorZoom) / 100) + "px";
            span.innerHTML = myOptions.text;
            spanParant.appendChild(span);
            TopParent.appendChild(spanParant);
            testDiv.appendChild(TopParent);
            //ctx.fillText(text, options.x + (options.width / 2), options.y + (options.fontSize));
          } else if (options.type === "basicShape") {
            // ctx.save();
            let charDiv = document.getElementById(
              "default-shape-" + options.key
            );
            let img = await loadBasicShape(charDiv);

            // ctx.translate(myOptions.width, myOptions.height);
            // ctx.rotate(options.rotateAngle * Math.PI / 180);
            // ctx.drawImage(img, myOptions.x, myOptions.y, myOptions.width, myOptions.height)
            // ctx.restore();
            if (img.width && img.height) {
              let _canvas = document.createElement("canvas");
              _canvas.width = img.width;
              _canvas.height = img.height;
              let _ctx = _canvas.getContext("2d");
              _ctx.drawImage(img, 0, 0);
              _canvas.style.left =
                Math.round((myOptions.x * EditorZoom) / 100) + "px";
              _canvas.style.top =
                Math.round((myOptions.y * EditorZoom) / 100) + "px";
              _canvas.style.width = (myOptions.width * EditorZoom) / 100 + "px";
              _canvas.style.height =
                (myOptions.height * EditorZoom) / 100 + "px";
              _canvas.style.position = "absolute";
              _canvas.style.transform = transformer;
              testDiv.appendChild(_canvas);
            }
          }
          resolve();
        });
      };
      for (let i = 0; i < LayersData.length; i++) {
        await print(LayersData[i]);
      }
      document.body.appendChild(testDiv);
      html2canvas(testDiv).then((can) => {
        const imgData = can.toDataURL("image/jpeg");
        let myImg = new Image();
        myImg.onload = function () {
          let resizedCanvas = document.createElement("canvas");
          let resizedData = calculateAspectRatioFit(
            myImg.width,
            myImg.height,
            200,
            200
          );
          resizedCanvas.width = resizedData.width;
          resizedCanvas.height = resizedData.height;
          let resizedCtx = resizedCanvas.getContext("2d");
          resizedCtx.drawImage(
            myImg,
            0,
            0,
            resizedCanvas.width,
            resizedCanvas.height
          );
          testDiv.remove();
          resolve_main(resizedCanvas.toDataURL("image/jpeg"));
        };
        myImg.src = imgData;
        // console.log(imgData)
      });
      // let resizedCanvas = document.createElement('canvas');
      // let resizedData = calculateAspectRatioFit(Canvas.width, Canvas.height, 200, 200);
      // resizedCanvas.width = resizedData.width;
      // resizedCanvas.height = resizedData.height;
      // let resizedCtx = resizedCanvas.getContext('2d');
      // resizedCtx.drawImage(Canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
      //console.log(Canvas.toDataURL("image/jpeg"))
      //resolve_main(resizedCanvas.toDataURL("image/jpeg"))
    });
  };

  //  useEffect(async() => {

  //     const array = Array.from(slides);
  //     let change = false;

  //     for (let i = 0; i < array.length; i++) {

  //       if (array[i].IsActive) {

  //         const _Added = array[i].LayerData.find(x=> x.Added === true || x.waitSS === true || x.deleted === true)

  //         if(_Added || array[i].deleted)
  //         {

  //           let thumbanilImgs = await screenShotCanvas2(array[i].SlideBackground, array[i].LayerData);
  //           let imagePath = await saveSlideServerSide(thumbanilImgs.minImg);
  //           array[i].LayerData.map(value => {value.Added = false; value.deleted = false; value.waitSS = false});
  //           array[i].SlideImage = imagePath;
  //           array[i].SlideBackgroundPic = authenticationData.ApiBaseURL + "/"+ imagePath;

  //           if(!array[i].backgroundSize)
  //           array[i].backgroundSize = "100%"

  //           array[i].deleted = false;
  //           // array[i].LayerData = LayersData;
  //           change = true;
  //         }
  //         else if (array[i].SlideBackground.type != "" && array[i].PrevSlideData != array[i].SlideBackground)
  //         {
  //           let thumbanilImgs = await screenShotCanvas2(array[i].SlideBackground, array[i].LayerData);
  //           let imagePath = await saveSlideServerSide(thumbanilImgs.minImg);
  //           array[i].SlideImage = imagePath;
  //           array[i].SlideBackgroundPic = authenticationData.ApiBaseURL + "/"+ imagePath;
  //           if(!array[i].backgroundSize)
  //           array[i].backgroundSize = "100%"
  //           array[i].PrevSlideData = array[i].SlideBackground
  //           // array[i].LayerData = LayersData;
  //           change = true;
  //         }

  //         break;
  //       }

  //     }

  //     if(change)
  //     {
  //       setslides(array);
  //     }

  //  }, [slides])

  const screenShotCanvas2 = async () => {
    return new Promise(async (resolve_main, reject_main) => {
      let _editor = document.getElementsByClassName("Editor")[0];
      let testDiv = document.createElement("div");
      testDiv.style.width = _editor.clientWidth + "px";
      testDiv.style.height = _editor.clientHeight + "px";
      testDiv.style.position = "relative";
      if (Backgrounds.type === "color") {
        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "gradient") {
        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "image") {
        let img = await loadImage(
          authenticationData.ApiBaseURL + "/" + Backgrounds.Path
        );
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);
      } else if (Backgrounds.type === "Animated") {
        let img = await loadImage(
          authenticationData.ApiBaseURL + "/" + Backgrounds.Path
        );
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);
      }
      const print = (options) => {
        return new Promise(async (resolve, reject) => {
          const myOptions = Object.assign({}, options);
          let flip = "";
          if (myOptions.flip === "scaleX(-1)") {
            flip = " scaleX(-1)";
          }
          let rotater = "";
          if (myOptions.rotateAngle) {
            rotater = `rotate(${myOptions.rotateAngle}deg)`;
          }
          let transformer = rotater + flip;
          if (options.type === "image") {
            let img = await loadImage(options.ImageSrc);
            img.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            img.style.top = Math.round((myOptions.y * EditorZoom) / 100) + "px";
            img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            img.style.position = "absolute";
            img.style.opacity = myOptions.opacity;
            img.style.transform = transformer;
            testDiv.appendChild(img);
          } else if (options.type === "Shape") {
            var path = options.ShapePath.replace(
              authenticationData.ApiBaseURL + "/",
              ""
            );
            let Shape = await loadImage(path);
            let _canvas = document.createElement("canvas");
            _canvas.width = Shape.width;
            _canvas.height = Shape.height;
            let _ctx = _canvas.getContext("2d");
            _ctx.drawImage(Shape, 0, 0);
            _canvas.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            _canvas.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            _canvas.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            _canvas.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            _canvas.style.position = "absolute";
            _canvas.style.transform = transformer;
            testDiv.appendChild(_canvas);
          } else if (options.type === "Video") {
            let video = await loadImage(options.ImageSrc);
            video.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            video.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            video.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            video.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            video.style.position = "absolute";
            video.style.transform = transformer;
            testDiv.appendChild(video);
          } else if (options.type === "Props") {
            let Props = await loadImage(options.PropImage);
            Props.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            Props.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            Props.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            Props.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            Props.style.position = "absolute";
            Props.style.transform = transformer;
            testDiv.appendChild(Props);
          } else if (options.type === "Character") {
            let charDiv = document.getElementById(
              "Outer-" + options.AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                let img = await loadCharacter(svg);
                img.style.left =
                  Math.round((myOptions.x * EditorZoom) / 100) + "px";
                img.style.top =
                  Math.round((myOptions.y * EditorZoom) / 100) + "px";
                img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
                img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
                img.style.position = "absolute";
                img.style.transform = transformer;
                testDiv.appendChild(img);
              } else {
                return;
              }
            }
          } else if (options.type === "AnimatedText") {
            let charDiv = document.getElementById(
              "Outer-" + options.AnimationId
            );

            if (charDiv) {
              let svg = charDiv.firstChild.firstChild;
              if (svg) {
                let img = await loadCharacter(svg);
                img.style.left =
                  Math.round((myOptions.x * EditorZoom) / 100) + "px";
                img.style.top =
                  Math.round((myOptions.y * EditorZoom) / 100) + "px";
                img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
                img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
                img.style.position = "absolute";
                img.style.transform = transformer;
                testDiv.appendChild(img);
              } else {
                return;
              }
            }
          } else if (options.type === "text") {
            let TopParent = document.createElement("div");
            TopParent.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            TopParent.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            TopParent.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            TopParent.style.height =
              (myOptions.height * EditorZoom) / 100 + "px";
            TopParent.style.position = "absolute";
            TopParent.style.transform = `rotate(${myOptions.rotateAngle}deg)`;
            let spanParant = document.createElement("div");
            spanParant.style.textAlign = myOptions.Align;
            let span = document.createElement("span");
            span.style.textDecoration = myOptions.textDec;
            span.style.fontStyle = myOptions.Fontstyle;
            span.style.fontWeight = myOptions.fontWeight;
            span.style.opacity = myOptions.opacity;
            span.style.color = myOptions.textColor;
            span.style.fontFamily = myOptions.googleFontSetting.fontFamily;
            span.style.fontSize =
              Math.round((myOptions.fontSize * EditorZoom) / 100) + "px";
            span.style.transformOrigin = `top left`;
            span.style.width = myOptions.spanWidth;
            span.style.lineHeight = myOptions.LineHeight;
            span.style.letterSpacing = myOptions.LetterSpacing + "em";
            span.innerHTML = myOptions.text;
            spanParant.appendChild(span);
            TopParent.appendChild(spanParant);
            testDiv.appendChild(TopParent);
          } else if (options.type === "basicShape") {
            let charDiv = document.getElementById(
              "default-shape-" + options.key
            );
            let img = await loadBasicShape(charDiv);

            let _canvas = document.createElement("canvas");
            _canvas.width = img.width;
            _canvas.height = img.height;
            let _ctx = _canvas.getContext("2d");
            _ctx.drawImage(img, 0, 0);
            _canvas.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            _canvas.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            _canvas.style.width = (myOptions.width * EditorZoom) / 150 + "px";
            _canvas.style.height = (myOptions.height * EditorZoom) / 150 + "px";
            _canvas.style.position = "absolute";
            _canvas.style.transform = transformer;
            testDiv.appendChild(_canvas);
          }

          resolve();
        });
      };
      for (let i = 0; i < LayersData.length; i++) {
        await print(LayersData[i]);
      }

      testDiv.style.zIndex = "-999999";
      testDiv.style.marginTop = "-1400px";
      document.body.appendChild(testDiv);

      html2canvas(testDiv).then((can) => {
        const imgData = can.toDataURL("image/jpeg");
        let myImg = new Image();
        myImg.onload = function () {
          let resizedCanvas = document.createElement("canvas");
          let resizedData = calculateAspectRatioFit(
            myImg.width,
            myImg.height,
            200,
            200
          );
          resizedCanvas.width = resizedData.width;
          resizedCanvas.height = resizedData.height;
          let resizedCtx = resizedCanvas.getContext("2d");
          resizedCtx.drawImage(
            myImg,
            0,
            0,
            resizedCanvas.width,
            resizedCanvas.height
          );
          testDiv.remove();
          let bothImages = {
            minImg: resizedCanvas.toDataURL("image/jpeg"),
            maxImg: imgData,
          };
          resolve_main(bothImages);

          // return bothImages;
        };
        myImg.src = imgData;
      });
    });
  };

  // const screenShotCanvas = () => {
  //     return new Promise(async (resolve_main, reject_main) => {
  //         let _editor = document.getElementsByClassName('Editor')[0];
  //         let Canvas = document.createElement('canvas');
  //         Canvas.width = _editor.clientWidth;
  //         Canvas.height = _editor.clientHeight;
  //         const getContext = () => Canvas.getContext('2d');
  //         const ctx = getContext();
  //         if (Backgrounds.type === 'color') {
  //             ctx.fillStyle = Backgrounds.color;
  //             ctx.fillRect(0, 0, Canvas.width, Canvas.height);
  //         }
  //         else if (Backgrounds.type === 'gradient') {
  //             var grd = ctx.createLinearGradient(0, 0, 0, Canvas.height);
  //             grd.addColorStop(0, Backgrounds.gradient.FirstColor);
  //             grd.addColorStop(1, Backgrounds.gradient.SecondColor);
  //             ctx.fillStyle = grd;
  //             ctx.fillRect(0, 0, Canvas.width, Canvas.height);
  //         }
  //         else if (Backgrounds.type === 'image') {
  //             let img = await loadImage(authenticationData.ApiBaseURL + '/' + Backgrounds.Path)
  //             ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
  //         }
  //         else {
  //             ctx.fillStyle = "#ffffff";
  //             ctx.fillRect(0, 0, Canvas.width, Canvas.height);
  //         }
  //         const print = options => {
  //             return new Promise(async (resolve, reject) => {
  //                 const myOptions = Object.assign({}, options);
  //                 if (options.type === "image") {
  //                     let img = await loadImage(options.ImageSrc)
  //                     ctx.drawImage(img, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
  //                 }
  //                 else if (options.type === "Shape") {
  //                     let Shape = await loadImage(options.ShapePath) //document.getElementsByClassName(options.Name)[0]
  //                     ctx.drawImage(Shape, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
  //                 }
  //                 else if (options.type === "Video") {
  //                     let video = await loadImage(options.ImageSrc) //document.getElementsByClassName(options.Name)[0]
  //                     ctx.drawImage(video, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
  //                 }
  //                 else if (options.type === "Props") {
  //                     let Props = await loadImage(options.PropImage)
  //                     ctx.drawImage(Props, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
  //                 }
  //                 else if (options.type === "Character") {
  //                     let charDiv = document.getElementById(options.AnimationId);
  //                     let svg = charDiv.firstChild;
  //                     ctx.drawImage(svg, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
  //                 }
  //                 else if (options.type === "text") {
  //                     ctx.font = `${options.fontWeight} ${options.fontSize + "px"} ${options.googleFontSetting.fontFamily}`;
  //                     ctx.fillStyle = options.textColor;
  //                     ctx.textAlign = options.Align;
  //                     ctx.font = options.googleFontSetting.fontFamily;
  //                     var lineheight = options.fontSize;
  //                     let text = options.text.replaceAll('<br>', '\n');
  //                     text = text.replaceAll('&nbsp;', ' ');
  //                     //console.log(text)
  //                     var lines = text.split('\n');

  //                     // for (var i = 0; i < lines.length; i++)
  //                     //     ctx.fillText(lines[i], options.x + (options.width / 2), options.y + (i * lineheight));
  //                     let heightDivider = lines.length > 1 ? 2 : 1
  //                     for (var i = 0; i < lines.length; i++) {
  //                         ctx.fillText(lines[i], options.x + (options.width / 2), options.y + (options.height / heightDivider) + (i * lineheight));
  //                     }
  //                     // ctx.font = `${options.fontWeight} ${options.fontSize + "px"} Roboto`;
  //                     // ctx.fillStyle = options.textColor;
  //                     // ctx.textAlign = options.Align;
  //                     // ctx.fillText(options.text, options.x + (options.width / 2), options.y + (options.fontSize), options.width);
  //                 }
  //                 else if (options.type === "basicShape") {
  //                     let charDiv = document.getElementById("default-shape-" + options.key);
  //                     //let svg = charDiv.firstChild;
  //                     let img = await loadCharacter(charDiv);
  //                     ctx.drawImage(img, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);

  //                 }
  //                 resolve();
  //             })
  //         };
  //         for (let i = 0; i < LayersData.length; i++) {
  //             await print(LayersData[i]);
  //         }

  //         let resizedCanvas = document.createElement('canvas');
  //         let resizedData = calculateAspectRatioFit(Canvas.width, Canvas.height, 200, 200);
  //         resizedCanvas.width = resizedData.width;
  //         resizedCanvas.height = resizedData.height;
  //         let resizedCtx = resizedCanvas.getContext('2d');
  //         resizedCtx.drawImage(Canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);

  //         resolve_main(resizedCanvas.toDataURL("image/jpeg"))
  //     })
  // }

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  function loadBasicShape(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.src = image64;
      } catch (error) {}
    });
  }

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        let div = document.createElement("div");
        div.innerHTML = xml;
        resolve(div);
      } catch (error) {}
    });
  }

  function loadImage(path) {
    return new Promise(async (resolve, reject) => {
      if (!path.includes(".svg")) {
        let imSrc = path;
        if (
          !path.includes("data:image/png;base64") &&
          !path.includes("data:image/jpeg;base64")
        ) {
          imSrc = await getImageSrc(path);
        }
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.src = imSrc;
      } else if (path.includes(".svg")) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL + "/api/Asset/getAsset?path=" + path,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            let img = new Image();
            img.onload = function () {
              resolve(img);
            };
            img.src = response.data;
          });
      }
    });
  }

  function getImageData(path) {}

  function getImageSrc(url) {
    return new Promise((resolve, reject) => {
      ImageURLToBase64(url).then(function (base64) {
        resolve(base64);
      });
    });
  }

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Images/ImageURLToBase64?url=" +
            url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() === "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;
            resolve(baseStr);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  const saveSlide2 = async () => {
    setDeafultLoader({ played: true, stat: true });
    if (!CanvasDisplay) {
      setCanvasDisplay(true);
    }
    const array = Array.from(LayersData);
    let thumbnailBase64 = await screenShotCanvas();
    for (var i = 0; i < array.length; i++) {
      if (array[i].toolbar === true) {
        array[i].toolbar = false;
      }
      if (array[i].Editable === true) {
        array[i].Editable = false;
      }
      if (array[i].type === "text") {
        array[i].edit = "false";
      }
      array[i].JSONValue = null;
    }
    const imgData = thumbnailBase64; //canvas.toDataURL('image/jpeg');
    const filt = Array.from(slides);
    var changeArray = filt.filter((item) => item.IsActive === true);
    let obj = {
      LayerData: JSON.stringify(array),
      IsActive: true,
      SlideBackground: JSON.stringify(changeArray[0].SlideBackground),
      TotalLength: changeArray[0].TotalLength,
      SlideImage: imgData,
      SmallTime: changeArray[0].SmallTime,
    };
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .post(authenticationData.ApiBaseURL + "/api/Slides/UploadSlide", obj, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        setDeafultLoader({ played: true, stat: false });
        if (response.data.status) {
          swal("Excellent", "Slide Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
        }
      })
      .catch((ex) => {
        console.log(ex);
        swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
      });
    setLayersData(array);
  };

  const clone = (obj) => {
    var copy;
    if (null === obj || "object" != typeof obj) return obj;
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  };

  const captureSS = async () => {
    setDeafultLoader({ played: true, stat: true });
    let thumbanilImgs = await screenShotCanvas2();

    const array = Array.from(slides);
    for (let i = 0; i < array.length; i++) {
      if (i === 0 && array[i] && array[i].IsActive) {
        let projectImagePath = await saveProjectPreviewImg(
          thumbanilImgs.maxImg
        );
        sessionStorage.setItem("max_img_path", projectImagePath);
      }
      if (array[i].IsActive) {
        let imagePath = await saveSlideServerSide(thumbanilImgs.minImg);

        array[i].SlideImage = imagePath;
        array[i].LayerData = LayersData;
        array[i].SlideBackground = Backgrounds;
        break;
      }
    }
    setslides(array);
    setDeafultLoader({ played: true, stat: false });
    swal("Excellent", "Slide Has Been Captured", "success");
  };

  const saveProjectPreviewImg = (maxImg) => {
    return new Promise((resolve, reject) => {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      var formdata = new FormData();
      formdata.append("base64", maxImg);
      axios
        .post(
          authenticationData.ApiBaseURL + "/api/Slides/CaptureProjectPreview",
          formdata,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((ex) => {
          console.log(ex);
          reject();
        });
    });
  };

  const saveSlideServerSide = (minImg) => {
    return new Promise((resolve, reject) => {
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      var formdata = new FormData();
      formdata.append("base64", minImg);
      axios
        .post(
          authenticationData.ApiBaseURL + "/api/Slides/CaptureSlide",
          formdata,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((ex) => {
          console.log(ex);
          reject();
        });
    });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      let array = Array.from(slides);

      const _PrevSlide = array[oldIndex];
      const _CurSlide = array[newIndex];

      const _PrevSlideStartBackground = _PrevSlide.startBackground;
      const _PrevSlideEndBackground = _PrevSlide.endBackground;

      const _CurSlideStartBackground = _CurSlide.startBackground;
      const _CurSlideEndBackground = _CurSlide.endBackground;

      array[oldIndex].startBackground = _CurSlideStartBackground;
      array[oldIndex].endBackground = _CurSlideEndBackground;

      if (array[oldIndex].IsActive) {
        array[oldIndex].LayerData = LayersData;
      }

      array[newIndex].startBackground = _PrevSlideStartBackground;
      array[newIndex].endBackground = _PrevSlideEndBackground;

      let changeData = arrayMove(array, oldIndex, newIndex);
      // The first slide has no transition into it (preview and export skip it): clear it when
      // another slide moves to the top, so the transition panel shows what will play.
      if ((oldIndex === 0 || newIndex === 0) && changeData[0]) {
        changeData[0].transitionName = "none";
        changeData[0].transitionType = "none";
      }

      array.map((value) => {
        value.isSlideHeader = true;
      });

      setslides(changeData);
    }
  };

  const onSortStart = (e) => {
    setCanvasDisplay(true);
  };

  return (
    <div className="tdStyle3">
      {ActiveIndex.key !== null && (
        <SlideSettings
          saveSlide2={saveSlide2}
          captureSS={captureSS}
          data={ActiveIndex}
          setdata={setActiveIndex}
          setList={setActiveList}
        />
      )}

      {ActiveList.key !== null && (
        <SelectCategory data={ActiveList} setdata={setActiveList} />
      )}
      {ShowTransitionPanel &&
        ShowTransitionPanel.state &&
        ShowTransitionPanel.slideKey != -1 && (
          <SlideTransitions
            ShowTransitionPanel={ShowTransitionPanel}
            setShowTransitionPanel={setShowTransitionPanel}
            LayersData={LayersData}
          />
        )}
      <div className="centeralWrapper">
        <div className="centerTopContent">
          <div className="slidesMenu">
            <div className="slidesMenuWrapper">
              <RightMenuTop />
              <SubSection
                ShowTransitionPanel={ShowTransitionPanel}
                setShowTransitionPanel={setShowTransitionPanel}
                ActiveIndex={ActiveIndex}
                setActiveIndex={setActiveIndex}
                onSortStart={onSortStart}
                onSortEnd={onSortEnd}
                useDragHandle
                lockAxis={"y"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSide;

const SubSection = SortableContainer(
  ({
    ActiveIndex,
    setActiveIndex,
    setShowPop,
    setShowTransitionPanel,
    ShowTransitionPanel,
  }) => {
    const {
      slides,
      setslides,
      setChangeCount,
      slide_background_image,
      setSlide_background_image,
    } = useContext(ProjectContext);
    const {
      LayersData,
      setLayersData,
      setUndoLayer,
      setRedoLayer,
      setpopShow,
      setMultiDrag,
      setIsPlayClicked,
      setcheckFunction,
      seteditableObject,
    } = useContext(MyContext);
    const {
      setTickerPosition,

      setClick_TickerPosition,

      setTickerState,
    } = useContext(TickerContext);

    const [Bgimage, setBgimage] = useState(false);

    const addSlide = () => {
      setpopShow(false);
      var checkKey = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].key >= checkKey) {
          checkKey = slides[i].key;
        }
      }
      let obj = {
        key: checkKey + 1,
        LayerData: [],
        IsActive: true,
        SlideBackground: {
          type: "",
          color: null,
          Path: null,
          gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
        },
        TotalLength: "00:00:10:00",
        SlideImage: null,
        SmallTime: "10.0 s",
        canvasWidth: parseInt(
          document
            .getElementsByClassName("EditorTrackInner")[0]
            .style.width.split("px")[0]
        ),
        canvasHeight: parseInt(
          document
            .getElementsByClassName("EditorTrackInner")[0]
            .style.height.split("px")[0]
        ),
      };

      const array2 = Array.from(LayersData);
      for (var i = 0; i < array2.length; i++) {
        array2[i].InMultiDrag = false;
        array2[i].showDiv = false;
        array2[i].Editable = false;
      }
      setLayersData(array2);

      const array = Array.from(slides);

      for (var i = 0; i < array.length; i++) {
        if (array[i].IsActive === true) {
          array[i].LayerData = LayersData;
        }
        array[i].IsActive = false;
      }
      setslides(array.concat(obj));
      setLayersData([]);
      setUndoLayer([]);
      setRedoLayer([]);
      //setChangeCount(6);

      //setting ticker to start
      setTickerPosition(0);
      setTickerState(0);
      setClick_TickerPosition(0);
      setIsPlayClicked(false);
      //Doing this to fix jerk on Start from Play
      setcheckFunction(true);

      //Resetting Multi Drag
      setMultiDrag([]);
      seteditableObject({ showPanel: false, editableItem: [] });
    };

    useEffect(() => {
      if (slide_background_image) {
        slides.map((value) => {
          if (slide_background_image.slide_key == value.key) {
            value.slideLoader = false;
            value.SlideImage = slide_background_image.path;
            setSlide_background_image(null);
          }
        });

        setBgimage(!Bgimage);
      }
    }, [slide_background_image]);

    return (
      <div className="slideSectionWrapper">
        <div className="slideSectionInsider scrollbar style-1">
          {slides.map((value, index) => {
            if (value.slideLoader === undefined) {
              value.slideLoader = false;
            }

            return (
              <React.Fragment key={index}>
                <SortableItem
                  ShowTransitionPanel={ShowTransitionPanel}
                  setShowTransitionPanel={setShowTransitionPanel}
                  setShowPop={setShowPop}
                  value={value}
                  ind={index}
                  index={index}
                  key={index.toString()}
                  ActiveIndex={ActiveIndex}
                  setActiveIndex={setActiveIndex}
                  SlideBackgroundPic={value.SlideImage}
                  slide_background_image={slide_background_image}
                />
              </React.Fragment>
            );
          })}
          <div
            className="addframe grow shadow-sm shadowHover "
            onClick={() => addSlide()}
          >
            <div className="add">
              <span className="material-icons">add_circle_outline</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

const SlideSettings = (props) => {
  const { slides, setslides, setChangeCount } = useContext(ProjectContext);
  const { LayersData, setUndoLayer, setRedoLayer, setLayersData } =
    useContext(MyContext);
  const { Role } = useContext(AuthContext);
  const { setGoto } = useContext(TickerContext);

  const AddBlank = () => {
    var checkKey = 0;

    // for (var i = 0; i < slides.length; i++) {
    //   if (slides[i].key >= checkKey) {
    //     checkKey = slides[i].key;
    //   }
    // }

    //commenting above code and rewriting map loop for ease.
    slides.map((item) => {
      if (item.key >= checkKey) {
        checkKey = item.key;
      }
    });

    var elem = document.getElementsByClassName("EditorTrackInner")[0];
    let obj = {
      key: checkKey + 1,
      LayerData: [],
      IsActive: true,
      SlideBackground: {
        type: "",
        color: null,
        Path: null,
        gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
      },
      TotalLength: "00:00:10:00",
      SlideImage: null,
      SmallTime: "10.0 s",
      canvasWidth: parseInt(elem.style.width.split("px")[0]),
      canvasHeight: parseInt(elem.style.height.split("px")[0]),
    };

    const array = Array.from(slides);

    for (var i = 0; i < array.length; i++) {
      if (array[i].IsActive === true) {
        array[i].IsActive = false;
        array[i].LayerData = LayersData;
      }
    }

    //Added this because it is needed to clear canvas for active slide
    setLayersData([]);

    let ind = props.data.index + 1;
    array.splice(ind, 0, obj);
    setslides(array);
    setUndoLayer([]);
    setRedoLayer([]);
    //setChangeCount(6);
    disappear();
  };

  const deleteSlide = () => {
    if (slides.length != 1) {
      const array = Array.from(slides);
      const removedAt = array.findIndex((item) => item.IsActive === true);
      const changeArray = array.filter((item) => item.IsActive !== true);
      // The first slide has no transition into it. Only when the first slide is deleted does
      // another slide become first. (Before, slide 2's transition was cleared whatever slide was
      // deleted.)
      if (removedAt === 0 && changeArray[0]) {
        changeArray[0].transitionName = "none";
        changeArray[0].transitionType = "none";
      }
      // Continue on the neighbouring slide (before: always the last slide).
      const next = Math.min(Math.max(removedAt, 0), changeArray.length - 1);
      changeArray[next].IsActive = true;
      setLayersData([]);
      setslides(changeArray);
      disappear();
    }
  };

  // Every slide needs its own key (slides are found by key) and every layer its own id (the
  // preview and the export look layers up by id). Unused ones are made here.
  const nextSlideKey = () =>
    slides.reduce((max, item) => (typeof item.key === "number" && item.key > max ? item.key : max), -1) + 1;

  const usedLayerIds = () => {
    const ids = new Set();
    slides.forEach((s) => (s.IsActive ? LayersData : s.LayerData || []).forEach((l) => l && ids.add(l.AnimationId)));
    return ids;
  };

  const newLayerId = (used, length) => {
    let id;
    do id = makeid(length); while (used.has(id));
    used.add(id);
    return id;
  };

  // const shiftTransitionsOneStepAhead = () => {
  //   var array = Array.from(slides);
  //   for(var i=0;i < array.length;i++){
  //     array[0].transitionName = "none"
  //     array[0].transitionType = "none"

  //   }
  // }

  const duplicateSlide = () => {
    const filt = Array.from(slides);
    var changeArray = filt.filter((item) => item.IsActive === true);

    let obj = {
      // Before: key = number of slides, which is already taken after a slide was deleted; two
      // slides then shared a key and selecting one selected both (edits went to both).
      key: nextSlideKey(),
      //fixed this it was a null object.
      LayerData: LayersData,
      IsActive: true,
      SlideBackground: changeArray[0].SlideBackground,
      TotalLength: changeArray[0].TotalLength,
      SlideImage: changeArray[0].SlideImage,
      SmallTime: changeArray[0].SmallTime,
      canvasWidth: changeArray[0].canvasWidth,
      canvasHeight: changeArray[0].canvasHeight,
    };

    let index = 0;
    const array = Array.from(slides);
    for (var i = 0; i < array.length; i++) {
      if (array[i].IsActive === true) {
        index = i;
        array[i].IsActive = false;
        array[i].LayerData = LayersData;
      }
    }

    //Doing this to avoid object cloning issue in javascript
    var deepClone = JSON.parse(JSON.stringify(obj));

    // Every layer of the copy gets its own id (before: only characters). With shared ids the
    // preview showed props, shapes and animated text of the copies on the wrong slide or not at
    // all, because it looks layers up by id.
    const used = usedLayerIds();
    deepClone.LayerData.forEach((item) => {
      item.AnimationId = newLayerId(used, item.type === "Character" ? 7 : 8);
      if (item.type === "text" && item.TextId) item.TextId = makeid(8);
    });
    //Added this because it is needed to clear canvas for active slide
    setLayersData([]);

    array.splice(index + 1, 0, deepClone);
    setslides(array);
    setUndoLayer([]);
    setRedoLayer([]);
    disappear();
    //setChangeCount(6);
  };

  const disappear = (params) => {
    props.setdata({ key: null, top: null, index: null });
  };

  const BuiltSeen = (params) => {
    setGoto({
      menu: "Scene",
      innerMenu: null,
      key: null,
    });
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  return (
    <div
      className="Setting_Container"
      onMouseEnter={() => {
        clearTimeout(handler);
      }}
      onMouseLeave={() => {
        disappear();
      }}
      style={{
        top: props.data.top,
        right: "95%",
        position: "absolute",
        zIndex: 99999,
      }}
    >
      <div className="Setting_Box">
        <div style={{ width: "100%", height: "100%" }}>
          <div className="Setting_Menu" style={{ width: "152px" }}>
            <div className="Setting_Menu_Items2 Setting_Menu_Items">
              {/* <div
                className="Setting_Single_items"
                style={{ paddingTop: "11px" }}
              >
                <div className="color_container">
                  <div className="styles_button" onClick={() => BuiltSeen()}>
                    <div className="Style_Button_style">
                      <span>
                        <svg
                          style={{ width: "32px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 450.6 362.6"
                          enableBackground="new 0 0 450.6 362.6"
                        >
                          <g>
                            <g>
                              <path
                                d="M400.5,362.2H50.1c-27.6,0-50-22.4-50-50V50.4c0-27.6,22.4-50,50-50h114.8c18,0,34.6,9.7,43.5,25.3L227,58.6
                                                            c4.1,7.2,11.7,11.7,20,11.7h153.5c27.6,0,50,22.4,50,50v191.9C450.5,339.7,428.1,362.2,400.5,362.2z M50.1,27.4
                                                            c-12.7,0-23,10.3-23,23v261.7c0,12.7,10.3,23,23,23h350.4c12.7,0,23-10.3,23-23V120.3c0-12.7-10.3-23-23-23H247
                                                            c-18,0-34.6-9.7-43.5-25.3l-18.6-32.8c-4.1-7.2-11.7-11.7-20-11.7H50.1z"
                              />
                            </g>
                            <g>
                              <path d="M450.5,129.3l-27-18.9V77.9c0-12.7-10.3-23-23-23H207.2v-27h193.3c27.6,0,50,22.4,50,50V129.3z" />
                            </g>
                          </g>
                          <path
                            d="M281.9,191.4h-45.5v-45.5c0-4.4-3.5-7.9-7.9-7.9h-6.5c-4.4,0-7.9,3.5-7.9,7.9v45.5h-45.5c-4.4,0-7.9,3.5-7.9,7.9v6.5
                                                    c0,4.4,3.5,7.9,7.9,7.9h45.5v45.5c0,4.4,3.5,7.9,7.9,7.9h6.5c4.4,0,7.9-3.5,7.9-7.9v-45.5h45.5c4.4,0,7.9-3.5,7.9-7.9v-6.5
                                                    C289.8,194.9,286.3,191.4,281.9,191.4z"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="styles_title" style={{ paddingTop: "7px" }}>
                      PreBuilt
                    </div>
                  </div>
                </div>
              </div>

              <div className="MenuSplit" /> */}

              <div
                className="Setting_Single_items"
                style={{ paddingTop: "11px" }}
              >
                <div className="color_container">
                  <div className="styles_button" onClick={AddBlank}>
                    <div className="Style_Button_style">
                      <span>
                        <svg
                          style={{ width: "32px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 450.6 362.6"
                          enableBackground="new 0 0 450.6 362.6"
                        >
                          <g>
                            <g>
                              <path
                                d="M400.5,361.6H50.1c-27.6,0-50-22.4-50-50V49.9c0-27.6,22.4-50,50-50h114.8c18,0,34.6,9.7,43.5,25.3L227,58
                                                                c4.1,7.2,11.7,11.7,20,11.7h153.5c27.6,0,50,22.4,50,50v191.9C450.5,339.2,428,361.6,400.5,361.6z M50.1,26.9
                                                                c-12.7,0-23,10.3-23,23v261.7c0,12.7,10.3,23,23,23h350.4c12.7,0,23-10.3,23-23V119.7c0-12.7-10.3-23-23-23H247
                                                                c-18,0-34.6-9.7-43.5-25.3l-18.6-32.8c-4.1-7.2-11.7-11.7-20-11.7H50.1z"
                              />
                            </g>
                            <g>
                              <path d="M450.5,182.6l-27-72.7V77.4c0-12.7-10.3-23-23-23H207.2v-27h193.3c27.6,0,50,22.4,50,50V182.6z" />
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div className="styles_title" style={{ paddingTop: "7px" }}>
                      Empty slide
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="Setting_Single_items"
                style={{ paddingTop: "11px" }}
              >
                <div className="color_container">
                  <div
                    className="styles_button"
                    onClick={() => {
                      if (Role === "admin") {
                        //console.log(props.data);
                        props.setList(props.data);
                        props.setdata({ index: null, key: null, top: null });
                      } else {
                        props.saveSlide2();
                      }
                    }}
                  >
                    <div className="Style_Button_style">
                      <span>
                        <svg
                          style={{ width: "32px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 450.6 362.6"
                          enableBackground="new 0 0 450.6 362.6"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M400.5,362.2H50.1c-27.6,0-50-22.4-50-50V50.4c0-27.6,22.4-50,50-50h114.8c18,0,34.6,9.7,43.5,25.3L227,58.6
                                                                        c4.1,7.2,11.7,11.7,20,11.7h153.5c27.6,0,50,22.4,50,50v191.9C450.5,339.7,428.1,362.2,400.5,362.2z M50.1,27.4
                                                                        c-12.7,0-23,10.3-23,23v261.7c0,12.7,10.3,23,23,23h350.4c12.7,0,23-10.3,23-23V120.3c0-12.7-10.3-23-23-23H247
                                                                        c-18,0-34.6-9.7-43.5-25.3l-18.6-32.8c-4.1-7.2-11.7-11.7-20-11.7H50.1z"
                                />
                              </g>
                              <g>
                                <path d="M450.5,124.4l-27-13.9V77.9c0-12.7-10.3-23-23-23H207.2v-27h193.3c27.6,0,50,22.4,50,50V124.4z" />
                              </g>
                            </g>
                            <g>
                              <path
                                d="M266.7,178.5l-36.1-62.4c-2.3-4.1-8.2-4.1-10.6,0L184,178.5c-2.3,4.1,0.6,9.1,5.3,9.1h24.8v74.6c0,2.9,2.3,5.2,5.2,5.2
                                                                    h12.1c2.9,0,5.2-2.3,5.2-5.2v-74.6h24.8C266.1,187.7,269,182.6,266.7,178.5z"
                              />
                            </g>
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div className="styles_title" style={{ paddingTop: "7px" }}>
                      Save Slide
                    </div>
                  </div>
                </div>
              </div>

              {Role === "admin" && (
                <div
                  className="Setting_Single_items"
                  style={{ paddingTop: "11px" }}
                >
                  <div className="color_container">
                    <div
                      className="styles_button"
                      onClick={() => {
                        if (Role === "admin") {
                          props.captureSS();
                        }
                      }}
                    >
                      <div className="Style_Button_style">
                        <span>
                          <svg
                            style={{ width: "32px" }}
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 450.6 362.6"
                            enableBackground="new 0 0 450.6 362.6"
                          >
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M400.5,362.2H50.1c-27.6,0-50-22.4-50-50V50.4c0-27.6,22.4-50,50-50h114.8c18,0,34.6,9.7,43.5,25.3L227,58.6
                                                                                    c4.1,7.2,11.7,11.7,20,11.7h153.5c27.6,0,50,22.4,50,50v191.9C450.5,339.7,428.1,362.2,400.5,362.2z M50.1,27.4
                                                                                    c-12.7,0-23,10.3-23,23v261.7c0,12.7,10.3,23,23,23h350.4c12.7,0,23-10.3,23-23V120.3c0-12.7-10.3-23-23-23H247
                                                                                    c-18,0-34.6-9.7-43.5-25.3l-18.6-32.8c-4.1-7.2-11.7-11.7-20-11.7H50.1z"
                                  />
                                </g>
                                <g>
                                  <path d="M450.5,124.4l-27-13.9V77.9c0-12.7-10.3-23-23-23H207.2v-27h193.3c27.6,0,50,22.4,50,50V124.4z" />
                                </g>
                              </g>
                              <g>
                                <path
                                  d="M266.7,178.5l-36.1-62.4c-2.3-4.1-8.2-4.1-10.6,0L184,178.5c-2.3,4.1,0.6,9.1,5.3,9.1h24.8v74.6c0,2.9,2.3,5.2,5.2,5.2
                                                                                h12.1c2.9,0,5.2-2.3,5.2-5.2v-74.6h24.8C266.1,187.7,269,182.6,266.7,178.5z"
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <div
                        className="styles_title"
                        style={{ paddingTop: "7px" }}
                      >
                        Capture SS
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="MenuSplit" />

              <div
                className="Setting_Single_items"
                style={{ paddingTop: "11px" }}
              >
                <div className="opacity">
                  <div
                    className="opacity styles_button"
                    onClick={duplicateSlide}
                  >
                    <div className="Style_Button_style">
                      <span>
                        <svg
                          style={{ width: "32px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 450.6 362.6"
                          enableBackground="new 0 0 450.6 362.6"
                        >
                          <g>
                            <path
                              d="M401.1-0.3H96.4c-24.6,0-44.8,19-46.7,43.1h24C75.5,31.9,85,23.6,96.4,23.6h304.7c12.7,0,23,10.3,23,23v226.3
		                                                c0,12.7-10.3,23-23,23V316c0,1.3-0.1,2.5-0.2,3.8h0.1c25.9,0,46.9-21,46.9-46.9V46.6C448,20.7,427-0.3,401.1-0.3z"
                            />
                            <path
                              d="M354.3,42.8H73.7h-24h-0.1c-25.9,0-46.9,21-46.9,46.9V316c0,25.9,21,46.9,46.9,46.9h304.7c24.6,0,44.8-19,46.7-43.1
		                                                c0.1-1.3,0.2-2.5,0.2-3.8v-20.1V89.7C401.2,63.8,380.1,42.8,354.3,42.8z M354.3,339H49.5c-12.7,0-23-10.3-23-23V89.7
		                                                c0-12.7,10.3-23,23-23c0,0,0,0,0.1,0h23.8h280.9c12.7,0,23,10.3,23,23v206.2V316c0,1.3-0.1,2.6-0.3,3.8
		                                                C375.1,330.7,365.6,339,354.3,339z"
                            />
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div className="styles_title" style={{ paddingTop: "7px" }}>
                      Duplicate
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="Setting_Single_items"
                style={{
                  paddingTop: "11px",
                  opacity: slides.length === 1 ? "0.5" : "1",
                }}
              >
                <div className="styles_button" onClick={deleteSlide}>
                  <div
                    className="Style_Button_style"
                    style={{
                      cursor: slides.length === 1 ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>
                      <svg
                        style={{ width: "32px" }}
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        id="Layer_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 450.6 362.6"
                        enableBackground="new 0 0 450.6 362.6"
                      >
                        <g>
                          <path
                            d="M221.4,288.1h7.8c4.1,0,7.4-3.3,7.4-7.4v-149c0-4.1-3.3-7.4-7.4-7.4h-7.8c-4.1,0-7.4,3.3-7.4,7.4v149
                                                        C214,284.8,217.3,288.1,221.4,288.1z"
                          />
                          <path
                            d="M168,288.1h7.8c4.1,0,7.4-3.3,7.4-7.4v-149c0-4.1-3.3-7.4-7.4-7.4H168c-4.1,0-7.4,3.3-7.4,7.4v149
                                                        C160.6,284.8,163.9,288.1,168,288.1z"
                          />
                          <path
                            d="M274.8,288.1h7.8c4.1,0,7.4-3.3,7.4-7.4v-149c0-4.1-3.3-7.4-7.4-7.4h-7.8c-4.1,0-7.4,3.3-7.4,7.4v149
                                                        C267.4,284.8,270.7,288.1,274.8,288.1z"
                          />
                          <path
                            d="M391.2,48h-98.9V31.7c0-17.6-14.3-31.8-31.8-31.8h-70.3c-17.6,0-31.8,14.3-31.8,31.8V48H59.5c-4.8,0-8.7,3.9-8.7,8.7V62
                                                        c0,4.8,3.9,8.7,8.7,8.7h28.7l22.7,248.5c2.3,24.8,22.8,43.5,47.7,43.5h136.9c12.1,0,23.6-4.5,32.5-12.7
                                                        c8.9-8.2,14.3-19.3,15.2-31.4l19.7-247.9h28.4c4.8,0,8.7-3.9,8.7-8.7v-5.3C399.9,51.9,396,48,391.2,48z M181,31.7
                                                        c0-5,4.1-9.1,9.1-9.1h70.3c5,0,9.1,4.1,9.1,9.1V48H181V31.7z M320.5,316.8c-1,13-12.1,23.2-25.1,23.2H158.5
                                                        c-13.1,0-23.9-9.8-25.1-22.9L111,70.7h229.1L320.5,316.8z"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                  <div className="styles_title" style={{ paddingTop: "7px" }}>
                    Delete
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SortableItem = SortableElement(
  ({
    setShowTransitionPanel,
    setShowPop,
    value,
    ind,
    ActiveIndex,
    setActiveIndex,
    ShowTransitionPanel,
    SlideBackgroundPic,
  }) => {
    const {
      slides,
      setslides,
      slide_background_image,
      setSlide_background_image,
    } = useContext(ProjectContext);

    const {
      LayersData,
      setLayersData,
      setUndoLayer,
      setRedoLayer,
      timelineZoomVal,
      changeTimelineZoomVal,
      popShow,
      setcheckFunction,
      setIsPlayClicked,
      setpopShow,
      setMultiDrag,
      seteditableObject,
    } = useContext(MyContext);
    const [showSlideTimeChangeModal, setshowSlideTimeChangeModal] =
      useState(false);

    const {
      setTickerPosition,
      TickerPosition,
      setTickerStart,
      ReverseLayer,
      setClick_TickerPosition,
      TickerRef,
      TickerState,
      setTickerState,
    } = useContext(TickerContext);

    const { authenticationData } = useContext(AuthContext);

    const IntialPoint = (params) => {
      let array = Array.from(params);
      for (let i = 0; i < array.length; i++) {
        if (array[i].originalX) {
          //array[i].x = array[i].originalX
        }
        if (array[i].originalY) {
          //array[i].y = array[i].originalY
        }
        if (array[i].originalWidth) {
          array[i].width = array[i].originalWidth;
        }
        if (array[i].originalHeight) {
          array[i].height = array[i].originalHeight;
        }
        if (array[i].originalFontSize) {
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].Editable = false;
        array[i].FurtherSetting = false;
        array[i].toolbar = false;
        array[i].Added = true;
        array[i].showDiv = false;
      }
      return array;
    };

    const ActiveSlide = (key, e) => {
      setpopShow(false);
      if (
        e.target.className.toString().includes("SVGAnimatedString") ||
        e.target.className.includes("slide-transition-setter-icon") ||
        e.target.className.includes("slide-transitoin-setter") ||
        e.target.className.includes("TransitionIcon")
      ) {
        return;
      }

      const array2 = Array.from(LayersData);
      for (var i = 0; i < array2.length; i++) {
        array2[i].InMultiDrag = false;
        array2[i].showDiv = false;
        array2[i].Editable = false;
        if (array2[i].Audio) array2[i].Audio.currentTime = 0;
      }
      setLayersData(array2);

      const array = Array.from(slides);
      let check = false;

      for (var i = 0; i < array.length; i++) {
        if (array[i].key === key) {
          if (array[i].IsActive != true) {
            array[i].IsActive = true;
            array[i].LayerData = array[i].LayerData;
            // array[i].LayerData = IntialPoint(array[i].LayerData);
            check = true;
          }
        } else if (array[i].IsActive === true) {
          array[i].IsActive = false;
          array[i].LayerData = LayersData;
          check = true;
        }
      }

      if (check) {
        setLayersData([]);
        setslides(array);
        setUndoLayer([]);
        setRedoLayer([]);
      }

      //setting ticker to start
      setTickerPosition(0);
      setTickerState(0);
      setClick_TickerPosition(0);
      setIsPlayClicked(false);
      //Doing this to fix jerk on Start from Play
      setcheckFunction(true);

      //Reset Multi Drag
      setMultiDrag([]);
      seteditableObject({ showPanel: false, editableItem: [] });
    };

    const setData = (e, key, ind) => {
      var offsets = e.target.offsetParent.getBoundingClientRect();
      setActiveIndex({ index: ind, key: key, top: offsets.top - 50 });
    };

    const ShowTransitionPanelWindow = () => {
      setShowTransitionPanel({
        state: true,
        slideKey: value.key,
        reset: ShowTransitionPanel.reset,
      });
    };

    // useEffect(() => {
    //   //console.log("index in cont");
    //   //console.log(ind);
    // }, [ind]);

    const [mouseOverSlideEffect, setmouseOverSlideEffect] = useState(false);

    return (
      //To make sure Sortable Item works , we have to right inline css and make sure to pass Index in SortableItem Component
      <>
        <SlideTimeChangeModal
          setshowSlideTimeChangeModal={setshowSlideTimeChangeModal}
          open={showSlideTimeChangeModal}
          slideNumber={ind}
          value={value}
        ></SlideTimeChangeModal>

        <div
          style={{
            height: "80px",
            width: "120px",
            background: "#fff",
            position: "relative",
            display: "inline-block",
            marginBottom: "10px",
            width: "100%",
            borderRadius: "5px",
            backgroundImage: SlideBackgroundPic
              ? `url(${
                  authenticationData.ApiBaseURL + "/" + SlideBackgroundPic
                })`
              : "",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",

            // backgroundColor: "purple"
          }}
          onMouseOver={() => setmouseOverSlideEffect(true)}
          onMouseLeave={() => setmouseOverSlideEffect(false)}
          className={
            " " + (value.IsActive ? "selectedFrame" : "UnselectedFrame")
          }
          onClick={(e) => {
            ActiveSlide(value.key, e);
          }}
        >
          {mouseOverSlideEffect && <div className="hoverSlideStyle"></div>}

          <Tooltip
            title="Double click to change."
            position="right"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
            distance={40}
          >
            <div
              onDoubleClick={() => setshowSlideTimeChangeModal(true)}
              className=""
              style={{
                background: "#000",
                position: "absolute",
                right: "3px",
                top: "3px",
                borderRadius: "5px",
                padding: "1px 2px",
              }}
            >
              <div
                style={{
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: "500",
                }}
              >
                {value.SmallTime}
              </div>
            </div>
          </Tooltip>

          <DragHandle />
          {value.slideLoader == true && (
            <div
              style={{
                width: "50px",
                height: "50px",
                marginLeft: "40px",
                marginTop: "15px",
                pointerEvents: "none",
              }}
            >
              <Lottie
                options={{ loop: true, autoplay: true, animationData: loader }}
                isStopped={false}
                isPaused={false}
              />
            </div>
          )}

          {ind != 0 && (
            <div
              className=""
              style={{
                display: "Inline-block",
                position: "absolute",
                left: "30px",
                top: "3.5px",
                cursor: "pointer",
              }}
            >
              <Tooltip
                title="Set Transition"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
              >
                <span
                  className="material-icons"
                  style={{ fontSize: "16px" }}
                  onClick={ShowTransitionPanelWindow}
                >
                  deblur
                </span>
                {/* <AutoAwesomeMotionIcon
                  onClick={ShowTransitionPanelWindow}
                  // className="shadowHover TransitionIcon"
                /> */}
              </Tooltip>
            </div>
          )}
          <span
            style={{
              // background: "#f2f2f2",
              position: "absolute",
              left: "3px",
              borderRadius: "2px",
              bottom: "3px",
              fontSize: "18px",
              cursor: "pointer",
            }}
            className="material-icons"
            onClick={(e) => {
              if (ActiveIndex.key === null) {
                setData(e, value.key, ind);
              }
            }}
            onMouseEnter={(e) => {
              if (ActiveIndex.key === null) {
                optHandler = setTimeout(function () {
                  setData(e, value.key, ind);
                }, 500);
              }
            }}
            onMouseLeave={(e) => {
              clearTimeout(optHandler);
              handler = setTimeout(function () {
                if (ActiveIndex.key != null) {
                  setActiveIndex({ key: null, top: null, index: null });
                }
              }, 500);
            }}
          >
            more_horiz
          </span>
        </div>
      </>
    );
  }
);

const SelectCategory = ({ data, setdata, send }) => {
  const { ScenesFolder } = useContext(MyContext);
  const [check, setcheck] = useState(null);
  const { slides, setDeafultLoader } = useContext(ProjectContext);
  const {
    LayersData,
    setLayersData,
    CanvasDisplay,
    setCanvasDisplay,
    Backgrounds,
    EditorZoom,
    Call_CurrentProject,
    setCall_CurrentProject,
  } = useContext(MyContext);
  const { authenticationData } = useContext(AuthContext);

  function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  // useEffect(() => {
  //   screenShotCanvas();
  //   const myTimer = setInterval(() => {
  //     screenShotCanvas();
  //   }, 3000);
  // }, []);

  const screenShotCanvas = () => {
    return new Promise(async (resolve_main, reject_main) => {
      let _editor = document.getElementsByClassName("Editor")[0];
      let testDiv = document.createElement("div");
      testDiv.style.width = _editor.clientWidth + "px";
      testDiv.style.height = _editor.clientHeight + "px";
      testDiv.style.position = "relative";
      // testDiv.style.display = "none";

      // let Canvas = document.createElement('canvas');
      // Canvas.width = _editor.clientWidth;
      // Canvas.height = _editor.clientHeight;
      // const getContext = () => Canvas.getContext('2d');
      // const ctx = getContext();

      if (Backgrounds.type === "color") {
        // ctx.fillStyle = Backgrounds.color;
        // ctx.fillRect(0, 0, Canvas.width, Canvas.height);
        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "gradient") {
        // var grd = ctx.createLinearGradient(0, 0, 0, Canvas.height);
        // grd.addColorStop(0, Backgrounds.gradient.FirstColor);
        // grd.addColorStop(1, Backgrounds.gradient.SecondColor);
        // ctx.fillStyle = grd;
        // ctx.fillRect(0, 0, Canvas.width, Canvas.height);

        testDiv.style.background = _editor.style.background;
      } else if (Backgrounds.type === "image") {
        let img = await loadImage(Backgrounds.Path);
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);
      } else if (Backgrounds.type === "Animated") {
        let img = await loadImage(Backgrounds.Path);
        //ctx.drawImage(img, 0, 0, Canvas.width, Canvas.height);
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.width = _editor.clientWidth + "px";
        img.style.height = _editor.clientHeight + "px";
        img.style.position = "absolute";
        testDiv.appendChild(img);

        // const ctx = BackgroundAnimation.current.getContext("2d");
        // var animationPath = authenticationData.ApiBaseURL + "/" + props.Item_Path;
        // const get = lottie.loadAnimation({
        //   name: props.Item_Path,
        //   renderer: "canvas",
        //   loop: true,
        //   autoplay: true,
        //   path: animationPath,
        //   rendererSettings: {
        //     context: ctx,
        //     clearCanvas: true,
        //     preserveAspectRatio: "xMidYMid meet",
        //   },
        // });
      }
      // else {
      //     ctx.fillStyle = "#ffffff";
      //     ctx.fillRect(0, 0, Canvas.width, Canvas.height);
      // }
      const print = (options) => {
        return new Promise(async (resolve, reject) => {
          const myOptions = Object.assign({}, options);
          let flip = "";
          if (myOptions.flip === "scaleX(-1)") {
            flip = " scaleX(-1)";
          }
          let rotater = "";
          if (myOptions.rotateAngle) {
            rotater = `rotate(${myOptions.rotateAngle}deg)`;
          }
          let transformer = rotater + flip;
          if (options.type === "image") {
            let img = await loadImage(options.ImageSrc);
            //ctx.drawImage(img, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);

            img.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            img.style.top = Math.round((myOptions.y * EditorZoom) / 100) + "px";
            img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            img.style.position = "absolute";
            img.style.transform = transformer;

            testDiv.appendChild(img);
          } else if (options.type === "Shape") {
            var path = options.ShapePath.replace(
              authenticationData.apiBaseurl + "/",
              ""
            );
            let Shape = await loadImage(options.ShapePath); //document.getElementsByClassName(options.Name)[0]
            //ctx.drawImage(Shape, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);

            let _canvas = document.createElement("canvas");
            _canvas.width = Shape.width;
            _canvas.height = Shape.height;
            let _ctx = _canvas.getContext("2d");
            _ctx.drawImage(Shape, 0, 0);
            _canvas.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            _canvas.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            _canvas.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            _canvas.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            _canvas.style.position = "absolute";
            _canvas.style.transform = transformer;
            testDiv.appendChild(_canvas);
          } else if (options.type === "Video") {
            let video = await loadImage(options.ImageSrc); //document.getElementsByClassName(options.Name)[0]

            // ctx.drawImage(video, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            video.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            video.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            video.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            video.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            video.style.position = "absolute";
            video.style.transform = transformer;
            testDiv.appendChild(video);
          } else if (options.type === "Props") {
            let Props = await loadImage(options.PropImage);

            //ctx.drawImage(Props, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            Props.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            Props.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            Props.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            Props.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            Props.style.position = "absolute";
            Props.style.transform = transformer;
            testDiv.appendChild(Props);
          } else if (
            options.type === "Character" ||
            options.type === "AnimatedText"
          ) {
            let charDiv = document.getElementById(
              "Loader" + options.AnimationId
            );
            let svg = charDiv.firstChild;
            let img = await loadCharacter(svg);
            //ctx.drawImage(svg, Math.round((myOptions.x * EditorZoom) / 100), Math.round((myOptions.y * EditorZoom) / 100), (myOptions.width * EditorZoom) / 100, (myOptions.height * EditorZoom) / 100);
            //let img = await loadImage(svg.toDataURL())
            img.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            img.style.top = Math.round((myOptions.y * EditorZoom) / 100) + "px";
            img.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            img.style.height = (myOptions.height * EditorZoom) / 100 + "px";
            img.style.position = "absolute";
            img.style.transform = transformer;
            testDiv.appendChild(img);
          } else if (options.type === "text") {
            // ctx.font = `${options.fontWeight} ${options.fontSize + "px"} ${options.googleFontSetting.fontFamily}`;
            // ctx.fillStyle = options.textColor;
            // ctx.textAlign = options.Align;
            // var lineheight = options.fontSize;
            // let text = options.text.replaceAll('<br>', '\n');
            // text = text.replaceAll('&nbsp;', ' ');
            // var lines = text.split('\n');
            // let heightDivider = lines.length > 1 ? 2 : 1
            // for (var i = 0; i < lines.length; i++) {
            //     ctx.fillText(lines[i], options.x + (options.width / 2), options.y + (options.height / heightDivider) + (i * lineheight), options.width);
            // }
            let TopParent = document.createElement("div");
            TopParent.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            TopParent.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            TopParent.style.width = (myOptions.width * EditorZoom) / 100 + "px";
            TopParent.style.height =
              (myOptions.height * EditorZoom) / 100 + "px";
            TopParent.style.position = "absolute";
            TopParent.style.transform = `rotate(${myOptions.rotateAngle}deg)`;
            let spanParant = document.createElement("div");
            spanParant.style.textAlign = myOptions.Align;
            let span = document.createElement("span");
            span.style.textDecoration = myOptions.textDec;
            span.style.fontStyle = myOptions.Fontstyle;
            span.style.fontWeight = myOptions.fontWeight;
            span.style.opacity = myOptions.opacity;
            span.style.color = myOptions.textColor;
            span.style.lineHeight = myOptions.LineHeight;
            span.style.letterSpacing = myOptions.LetterSpacing + "em";
            span.style.fontFamily = myOptions.googleFontSetting.fontFamily;
            span.style.fontSize =
              Math.round((myOptions.fontSize * EditorZoom) / 100) + "px";
            span.innerHTML = myOptions.text;
            spanParant.appendChild(span);
            TopParent.appendChild(spanParant);
            testDiv.appendChild(TopParent);
            //ctx.fillText(text, options.x + (options.width / 2), options.y + (options.fontSize));
          } else if (options.type === "basicShape") {
            // ctx.save();
            let charDiv = document.getElementById(
              "default-shape-" + options.key
            );
            let img = await loadBasicShape(charDiv);

            // ctx.translate(myOptions.width, myOptions.height);
            // ctx.rotate(options.rotateAngle * Math.PI / 180);
            // ctx.drawImage(img, myOptions.x, myOptions.y, myOptions.width, myOptions.height)
            // ctx.restore();
            let _canvas = document.createElement("canvas");
            _canvas.width = img.width;
            _canvas.height = img.height;
            let _ctx = _canvas.getContext("2d");
            _ctx.drawImage(img, 0, 0);
            _canvas.style.left =
              Math.round((myOptions.x * EditorZoom) / 100) + "px";
            _canvas.style.top =
              Math.round((myOptions.y * EditorZoom) / 100) + "px";
            _canvas.style.width = (myOptions.width * EditorZoom) / 150 + "px";
            _canvas.style.height = (myOptions.height * EditorZoom) / 150 + "px";
            _canvas.style.position = "absolute";
            _canvas.style.transform = transformer;
            testDiv.appendChild(_canvas);
          }
          resolve();
        });
      };
      for (let i = 0; i < LayersData.length; i++) {
        await print(LayersData[i]);
      }
      document.body.appendChild(testDiv);
      const temp = html2canvas(testDiv).then((can) => {
        const imgData = can.toDataURL("image/jpeg");
        let myImg = new Image();
        myImg.onload = function () {
          let resizedCanvas = document.createElement("canvas");
          let resizedData = calculateAspectRatioFit(
            myImg.width,
            myImg.height,
            200,
            200
          );
          resizedCanvas.width = resizedData.width;
          resizedCanvas.height = resizedData.height;
          let resizedCtx = resizedCanvas.getContext("2d");
          resizedCtx.drawImage(
            myImg,
            0,
            0,
            resizedCanvas.width,
            resizedCanvas.height
          );
          testDiv.remove();
          resolve_main(resizedCanvas.toDataURL("image/jpeg"));
        };
        myImg.src = imgData;
      });
      // let resizedCanvas = document.createElement('canvas');
      // let resizedData = calculateAspectRatioFit(Canvas.width, Canvas.height, 200, 200);
      // resizedCanvas.width = resizedData.width;
      // resizedCanvas.height = resizedData.height;
      // let resizedCtx = resizedCanvas.getContext('2d');
      // resizedCtx.drawImage(Canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
      //console.log(Canvas.toDataURL("image/jpeg"))
      //resolve_main(resizedCanvas.toDataURL("image/jpeg"))
    });
  };

  function loadBasicShape(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        var svg64 = btoa(xml);
        var b64Start = "data:image/svg+xml;base64,";
        var image64 = b64Start + svg64;
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.src = image64;
      } catch (error) {}
    });
  }

  function loadCharacter(svg) {
    return new Promise((resolve, reject) => {
      try {
        var xml = new XMLSerializer().serializeToString(svg);
        let div = document.createElement("div");
        div.innerHTML = xml;
        resolve(div);
      } catch (error) {}
    });
  }

  function loadImage(path) {
    return new Promise(async (resolve, reject) => {
      let imSrc = path;
      if (
        !path.includes("data:image/png;base64") &&
        !path.includes("data:image/jpeg;base64")
      ) {
        imSrc = await getImageSrc(path);
      }

      let img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.src = imSrc;
    });
  }

  function getImageSrc(url) {
    return new Promise((resolve, reject) => {
      if (url.includes(".svg")) {
        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
        axios
          .get(
            authenticationData.ApiBaseURL + "/api/Asset/getAsset?path=" + url,
            {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + authData.access_token,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          });
      } else {
        let _apiUrl;

        if (url.includes("videos")) {
          _apiUrl = url;
        } else {
          _apiUrl = authenticationData.ApiBaseURL + "/" + url;
        }

        var xhr = new XMLHttpRequest();
        xhr.timeout = 9000000;
        xhr.open("GET", _apiUrl, true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type");
        xhr.responseType = "blob";
        xhr.onload = function (o) {
          if (this.status === 200) {
            var reader = new FileReader();
            reader.onloadend = function () {
              resolve(reader.result);
            };
            reader.readAsDataURL(this.response);
            //console.log(url);
          }
        };
        xhr.onerror = function (e) {
          ImageURLToBase64(authenticationData.ApiBaseURL + "/" + url).then(
            function (base64) {
              resolve(base64);
            }
          );
        };
        xhr.send();
      }
    });
  }

  const ImageURLToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      var splittedURL = url.split("/");
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split(".")[1];

      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Images/ImageURLToBase64?url=" +
            url,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          if (response.data != null && response.data != "") {
            var format = "data:image/jpeg;base64,";
            if (extension.toLowerCase() === "png") {
              format = "data:image/png;base64,";
            }
            var baseStr = format + response.data;

            resolve(baseStr);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  const saveSlide = async () => {
    if (check != null) {
      setDeafultLoader({ played: true, stat: true });

      if (!CanvasDisplay) {
        setCanvasDisplay(true);
      }

      const array = Array.from(LayersData);
      let thumbnailBase64 = await screenShotCanvas();

      //console.log(thumbnailBase64);

      for (var i = 0; i < array.length; i++) {
        if (array[i].toolbar === true) {
          array[i].toolbar = false;
        }
        if (array[i].Editable === true) {
          array[i].Editable = false;
        }
        if (array[i].type === "text") {
          array[i].edit = "false";
        }
        array[i].JSONValue = null;
      }
      const imgData = thumbnailBase64; // canvas.toDataURL('image/jpeg');
      const filt = Array.from(slides);
      var changeArray = filt.filter((item) => item.IsActive === true);
      let obj = {
        LayerData: JSON.stringify(array),
        IsActive: true,
        SlideBackground: JSON.stringify(changeArray[0].SlideBackground),
        TotalLength: changeArray[0].TotalLength,
        SlideImage: changeArray[0].SlideImage,
        SmallTime: changeArray[0].SmallTime,
        CategoryId: check,
        canvasWidth: parseInt(
          document
            .getElementsByClassName("EditorTrackInner")[0]
            .style.width.split("px")[0]
        ),
        canvasHeight: parseInt(
          document
            .getElementsByClassName("EditorTrackInner")[0]
            .style.height.split("px")[0]
        ),
      };
      let authData = JSON.parse(
        localStorage.getItem("animation_studio_2.0_access_token")
      );

      axios
        .post(authenticationData.ApiBaseURL + "/api/Slides/UploadSlide", obj, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          setDeafultLoader({ played: true, stat: false });
          if (response.data.status) {
            swal("Excellent", "Slide Has Been Uploaded", "success");
          } else {
            swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
          }
        })
        .catch((ex) => {
          swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
        });
      //setLayersData(array);

      // let input = document.getElementsByClassName('EditorTrackInner')[0];

      // html2canvas(input)
      //     .then((canvas) => {
      //         const imgData = canvas.toDataURL('image/jpeg');
      //         console.log(imgData)
      // const filt = Array.from(slides);
      // var changeArray = filt.filter(item => item.IsActive === true);
      // let obj = {
      //     LayerData: JSON.stringify(array),
      //     IsActive: true,
      //     SlideBackground: JSON.stringify(changeArray[0].SlideBackground),
      //     TotalLength: changeArray[0].TotalLength,
      //     SlideImage: imgData,
      //     SmallTime: changeArray[0].SmallTime,
      //     CategoryId: check
      // }
      // let authData = JSON.parse(
      //     localStorage.getItem("animation_studio_2.0_access_token")
      // );

      // axios.post(authenticationData.ApiBaseURL + "/api/Slides/UploadSlide", obj, {
      //     headers: {
      //         "Content-Type": "application/json",
      //         "Access-Control-Allow-Origin": "*",
      //         Authorization: "Bearer " + authData.access_token,
      //     },
      // }).then(response => {
      //     setDeafultLoader({ played: true, stat: false })
      //     if (response.data.status) {
      //         swal("Excellent", "Slide Has Been Uploaded", "success");
      //     }
      //     else {
      //         swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
      //     }
      // }).catch((ex) => {
      //     console.log(ex);
      //     swal("Failed", "Unable to Upload Slide. Please Try Again", "error");
      // });
      //});
    } else {
      alert("no Category selected");
    }
  };

  return (
    <div
      style={{
        top: data.top,
        right: "95%",
        position: "absolute",
        zIndex: 99999,
        animation: "fadeIn 0.5s",
      }}
    >
      <div
        className=" shadow-sm border-0 dropdown-menu show"
        style={{
          position: "relative",
          boxshadow: "0 8px 16px rgb(0 0 0 / 39%)",
        }}
      >
        <div style={{ height: "306px", overflowY: "scroll" }}>
          {ScenesFolder.map((lmc, index) => (
            <React.Fragment key={index}>
              <div
                key={index.toString()}
                className="dropUpperDiv py-2 px-2"
                onClick={() => {
                  setcheck(lmc.id);
                }}
              >
                <span className="noHover dropdown-item">
                  {check === lmc.id && (
                    <span className="material-icons DropDownIcon noHover">
                      done{" "}
                    </span>
                  )}
                  <span className="ml-4">{lmc.categoryName}</span>
                </span>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div>
          <button onClick={saveSlide}>save</button>
          <button
            style={{ float: "right" }}
            onClick={() => {
              setdata({ index: null, key: null, top: null });
            }}
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  );
};
